<button
  type="button"
  class="inline-flex w-8 h-8 p-0 items-center justify-center surface-0 dark:surface-800"
  (click)="onThemeToggler()"
>
  <i [ngClass]="'pi ' + iconClass()" class="dark:text-white"></i>
</button>
